import { useContext } from "react";
import { useNavigate } from "react-router";
import { GlobalContextData, GetGlobalContext } from "../classes/context";
import { Link } from "react-router-dom";

type HeaderProps = {
    user?: string;
    onToggleSidenav: () => void;
}

export default function Header(props: HeaderProps): JSX.Element {
    const globalContext = useContext<GlobalContextData>(GetGlobalContext);
    const navigate = useNavigate();

    const onLogout = () => {
        let newContext = { ...globalContext.vars };
        newContext.esercente = undefined;
        globalContext.update(newContext);
        localStorage.removeItem('ric');
        navigate('/');
    }

    return (
        <header>
            <div id="sidenav-toggler" onClick={props.onToggleSidenav}>
                <i className="bi bi-list"></i>
            </div>
            <div className="ms-auto d-flex align-items-center">
                <ul className="header-list">
                    {/* <li>
                        <i className="bi bi-bell"></i>
                    </li> */}
                    <li className="dropdown">
                        <div className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                            <i className="bi bi-person-circle"></i>
                            <span className="ms-2">{props.user}</span>
                        </div>

                        <ul className="dropdown-menu">
                            {/* <li><Link className="dropdown-item" to="/">Impostanzioni</Link></li> */}
                            <li onClick={onLogout}><a className="dropdown-item" >Logout</a></li>
                        </ul>
                    </li>
                </ul>
            </div>
        </header>
    );
}